export default __webpack_public_path__ + "static/media/weth.02267002.svg";